import {namespace, mergeDeep} from './common/Utils';
import NcoinGift from './ncoin/NcoinGift';
import IdVerify from './idVerify/IdVerify'
import Modal from './modal/Modal';
import AlertConfirm from './modal/AlertConfirm';
import Toast from './modal/Toast';
import NcBanner from './ncBanner/NcBanner';


class App {
	constructor(_config = {}) {
		const config = mergeDeep({
			wstatic:'https://wstatic-cdn.plaync.com', 
			isLogin: false, 
			useIdVerify: true,
			useNcoinGift: true,
			ncBanner: {},
		}, _config);
		    
        if ( config.useIdVerify ){
			this.idverify = new IdVerify(config);
		}

        if ( config.useNcoinGift ){
			this.ncoin = new NcoinGift(config);
		}
		
		this.Modal = Modal;
		
		const alertApp = new AlertConfirm(AlertConfirm.TYPE_ALERT);
		this.alert = alertApp.open.bind(alertApp);
		
		const confirmApp = new AlertConfirm(AlertConfirm.TYPE_CONFIRM);
		this.confirm = confirmApp.open.bind(confirmApp);

		const toastApp = new Toast(Toast.TYPE_TOAST);
		this.toast = toastApp.open.bind(toastApp);
		this.ncBanner = new NcBanner(config);
	}
	
}



namespace('nc.rwd.common');
nc.rwd.common = App;